import pdfMake, { userMark, setMyConfig, makeTableContent } from "@/utils/pdf";

function pdfReporteGuias(payload) {
  const columns = [
    {
      key: "tabla",
      label: "Tabla",
      width: "auto"
    },
    {
      key: "codigo",
      label: "Cód.",
      width: "auto"
    },
    {
      key: "fecha",
      label: "Fecha",
      width: "auto"
    },
    {
      key: "servicio",
      label: "Servicio",
      width: "*"
    },
    {
      key: "conductor",
      label: "Conductor",
      width: "*"
    },
    {
      key: "usuarioCreador",
      label: "U. Creador",
      width: 100
    },
    {
      key: "usuarioModificador",
      label: "U. Modificador",
      width: 100
    }
  ];

  const table = makeTableContent([...payload.records], columns);

  pdfMake
    .createPdf({
      info: {
        title: `Reporte por movilidad`
      },
      content: [
        {
          text: "Reporte por movilidad",
          style: "h1"
        },
        {
          columns: [
            {
              text: `Vehículo: ${payload.header.vehiculo}`,
              width: "auto"
            },
            {
              text: `Fecha Inicio: ${payload.header.fechaInicio}`,
              width: "auto"
            },
            {
              text: `Fecha Fin: ${payload.header.fechaFin}`,
              width: "auto"
            }
          ],
          margin: [0, 0, 0, 5]
        },
        table,
        ...userMark(payload.userMark, payload.dateMark)
      ],
      ...setMyConfig()
    })
    .print();
}

export default pdfReporteGuias;
